import { render, staticRenderFns } from "./cbti.vue?vue&type=template&id=17dcdcc8&scoped=true"
import script from "./cbti.vue?vue&type=script&lang=js"
export * from "./cbti.vue?vue&type=script&lang=js"
import style0 from "./cbti.vue?vue&type=style&index=0&id=17dcdcc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dcdcc8",
  null
  
)

export default component.exports